export default {
  feedback: {
    usage_threshold: 'Minimum basket amount for this promo is (excl. delivery costs)',
    promo_code_added: 'Promo code successfully applied',
  },
};
